import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './core/containers/app/app';
import { FeathersAppService } from '@fire/feathers';

import 'hammerjs';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { CustomRouterStateSerializer } from './core/utils/router.utils';
import { CoreModule } from './core/core.module';
import { SampleModule } from './sample/sample.module';
import { AdminAreaModule } from './admin-area/admin-area.module';
import { AppRoutingModule } from './app-routing.module';
import { ConfigService } from './core/services/config.service';



export function appInit(configService:ConfigService) {
  // NOTE: this factory needs to return a function (that in turn returns a promise)
  return () => configService.load()
}



@NgModule({
  declarations: [],
  imports: [

    // @angular
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,


    /**
     * StoreModule.forRoot is imported once in the root module, accepting a reducer
     * function or object map of reducer functions. If passed an object of
     * reducers, combineReducers will be run creating your application
     * meta-reducer. This returns all providers for an @ngrx/store
     * based application.
     */
    StoreModule.forRoot(reducers, { metaReducers }),


    /**
     * @ngrx/router-store keeps router state up-to-date in the store.
     */
    StoreRouterConnectingModule,


    /**
     * EffectsModule.forRoot() is imported once in the root module and
     * sets up the effects class to be initialized immediately when the
     * application starts.
     *
     * See: https://github.com/ngrx/platform/blob/master/docs/effects/api.md#forroot
     */
    EffectsModule.forRoot([]),


    // app modules
    CoreModule,
    SampleModule,
    AdminAreaModule,


    // main app routes
    AppRoutingModule,
  ],
  providers: [

    ConfigService,

    {
      'provide': APP_INITIALIZER,
      'useFactory': appInit,
      'deps': [ConfigService, HttpClientModule],
      'multi': true,
    },


    /**
     * The `RouterStateSnapshot` provided by the `Router` is a large complex structure.
     * A custom RouterStateSerializer is used to parse the `RouterStateSnapshot` provided
     * by `@ngrx/router-store` to include only the desired pieces of the snapshot.
     */
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },


    FeathersAppService,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/app.module.ts